import { Component, input } from '@angular/core';
import {
  RdsButtonModule,
  RdsIconsModule,
  RdsLinkModule,
} from '@rds/angular-components';
import { DynamicModule } from 'ng-dynamic-component';
import { RouterModule } from '@angular/router';
import { OfferingCardComponent } from '../../shared/offering-card/offering-card.component';

@Component({
  selector: 'inexp-offering-related',
  imports: [
    DynamicModule,
    RdsButtonModule,
    RdsIconsModule,
    RouterModule,
    RdsLinkModule,
    OfferingCardComponent,
  ],
  templateUrl: './offering-related.component.html',
  styleUrl: './offering-related.component.scss',
})
export class OfferingRelatedComponent {
  _uid = input<string>();
  component = input<string>();
  extraSection = input<string>();
  similarOfferings = input<any[]>();

}
